import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';

export const removeUserFromPermissionGroupOperation = async (
  groupId: number,
  userId: number,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.removeUserFromPermissionGroup(groupId, userId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    toast.success('המשתמש הוסר מהקבוצה בהצלחה');
    onSuccess();
  } catch (e) {
    console.error('removeUserFromPermissionGroupOperation failed:', e);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
